<template>
  <mt-popup
      v-model="visible"
      class="select-coupon"
      mg-stat-mod="c_hwcouponpop"
      position="bottom"
  >
    <header>
      {{ showRule ? "使用规则" : "优惠券" }}
      <div
          v-if="!showRule"
          :mg-stat-custom="'cont=使用规则&label=span&direct=cntp'"
          :mg-stat-lob="`couponid=${nowId}`"
          mg-stat-click
          @click="showRule = true"
      >
        <i class="icon help"></i>
        <span>使用规则</span>
      </div>
    </header>
    <div id="coupon-content">
      <coupon-rule v-if="showRule"></coupon-rule>
      <coupon-item
          v-else-if="hasCoupon"
          :goodsids="goodsids"
          :list="couponList"
          @change="getCouponInfo"
      ></coupon-item>
      <div v-else class="no-coupon">
        <div>
          <img :src="bgImg"/>
        </div>
        <div>暂无可用优惠券哦~</div>
      </div>
    </div>
    <footer
        :mg-stat-custom="`cont=${
        showRule ? '关闭' : '确定'
      }&label=btn&direct=cntp`"
        :mg-stat-mod="`${showRule ? 'c_hwcouponuserulepop' : 'c_hwcouponpop'}`"
        mg-stat-click
        @click="submit"
    >
      {{ showRule ? "关闭" : "完成" }}
    </footer>
  </mt-popup>
</template>
<script>
import MgStat from 'MgStat';
import bgImg from 'assets/img/paidfail.png';
import CouponItem from '../CouponItem';
import CouponRule from '../CouponRule';

export default {
  props: ['visible', 'from', 'couponList', 'goodsids'],
  components: { CouponItem, CouponRule },
  data() {
    return {
      bgImg,
      canUse: 1,
      nowId: 0,
      showRule: false,
      fff: [
        {
          price: '10',
          id: 1,
          limit: '满100元可用',
          tagName: '全店通用',
          desc: '代金券描述代金券代金券描述代金券描述描述',
          date: '2019.10.1号到期',
        },
      ],
      ddd: [],
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (!val) {
          this.$emit('close', val);
        }
        if (val) {
          this.showRule = this.from === 'coupon';
        }
      },
    },
    showRule: {
      handler(val) {
        if (val) {
          MgStat.send(
            'cv',
            {
              goods_id: this.goodsids,
            },
            {
              mod: 'c_hwcouponuserulepop',
            },
          );
        }
      },
    },
  },
  computed: {
    hasCoupon() {
      return this.couponList.length;
    },
  },
  mounted() {
    const height = document.body.clientHeight;
    const ele = document.getElementById('coupon-content');
    if (height < 500) {
      ele.style.height = '230px';
    } else {
      ele.style.height = `${height * 0.45}px`;
    }
  },
  methods: {
    getCouponInfo({
      id, price, saleType, name,
    }) {
      this.nowId = id;
      this.nowPrice = price;
      this.nowSaleType = saleType;
      this.nowName = name;
    },
    submit() {
      if (this.showRule) {
        this.showRule = false;
        if (this.from === 'coupon') {
          this.$emit('close', false);
        }
        return;
      }
      if (!this.hasCoupon) {
        this.$emit('close', false);
        return;
      }
      /* this.$toast({
        message: '领取成功',
        iconClass: 'icon selected',
        duration: 1000,
      }); */
      this.$emit('change', {
        id: this.nowId,
        price: this.nowPrice,
        sale_type: this.nowSaleType,
        name: this.nowName,
      });
    },
  },
};
</script>
<style lang="scss">
.mint-toast {
  padding: 15px 60px !important;
  font-size: 0.3rem !important;
}

.mint-toast-text {
  font-size: 0.3rem !important;
}

.select-coupon {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;

  .no-coupon {
    width: 250px;
    margin: 0 auto;
    padding-top: 54px;
    text-align: center;

    img {
      width: 178px;
      height: 131px;
    }

    div {
      font-size: 24px;
      color: #6f6f6f;

      & + div {
        margin-top: 47px;
      }
    }
  }

  header {
    width: 100%;
    padding: 32px 0;
    text-align: center;
    font-size: 30px;
    color: #4a4a4a;
    position: relative;

    div {
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
      top: 38px;

      span {
        font-size: 22px;
        color: #ff5f00;
        margin-left: 8px;
      }
    }
  }

  footer {
    width: 100%;
    height: 81px;
    color: #fff;
    margin-bottom: 14px;
    font-size: 30px;
    text-align: center;
    line-height: 81px;
    background: linear-gradient(
            90deg,
            rgba(250, 132, 27, 1) 0%,
            rgba(255, 96, 2, 1) 100%
    );
    border-radius: 12px;
  }
}
</style>

